export const errors = {
    required: 'Valid amount required',
    minLength: 'Please enter amount $',
    maxLength: 'Please enter amount $',
    invalid: 'Invalid format; dollars with option cents required'
};
